"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getContactByType = require("./getContactByType");
Object.keys(_getContactByType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getContactByType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getContactByType[key];
    }
  });
});
var _getTopAreaBannerType = require("./getTopAreaBannerType");
Object.keys(_getTopAreaBannerType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getTopAreaBannerType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getTopAreaBannerType[key];
    }
  });
});